// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSimple_root__1At3n","logo":"LayoutSimple_logo__3S4-W","wave1":"LayoutSimple_wave1__1U46I","wave2":"LayoutSimple_wave2__2W8G5","wave3":"LayoutSimple_wave3__2Okk-"};